/**
 * Refers to version of persisted store in localStorage.
 *
 * Whenever you need to update constants for example, this should be updated as well.
 */
export const CURRENT_VERSION = '1.6';



// WEBPACK FOOTER //
// ./app/constants/config.js